import { render } from "./AboutSection.vue?vue&type=template&id=17b4a641&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=17b4a641&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b4a641"]])

export default __exports__